module.exports = __webpack_public_path__ + "img/login-v2-dark.4b681b5a.svg";